import * as Table from '../Table';
import styles from './styles/Draggable.module.css';

type Props = { value: string | null | undefined };

export const Cell = (props: Props) => {
  return <Table.Body.TD className={styles.title}>{props.value || 'N/A'}</Table.Body.TD>;
};

Cell.displayName = 'Column.Category.Cell';

export const Header = (props: unknown) => {
  return <Table.Header.TH className={styles.title}>Tag Category</Table.Header.TH>;
};

Header.displayName = 'Column.Category.Header';
